export const EVENT_SEARCHING_PATIENT_STATUS = 'searchingPatient.status';
export const EVENT_PATIENT_DELETE_TEST = 'patient.tests.deleteTest';
export const EVENT_TEST_VALIDATED = 'test.validated';
export const EVENT_TEST_INPUT_COMPONENT_RENDERED = "test.input.component.rendered";
// export const EVENT_ANALYTIC_DATE_RANGE = 'analytic.daterange';

export const PARAM_SEARCHING = 'searching';
export const PARAM_TEST_ID = 'testId';

export const REFRESH_OVERVIEW = 'refreshOverview';
export const REFRESH_PENDING_TEST_COUNT = 'refreshPendingTestCount';
// export const DATE_FROM = 'dateFrom';
// export const DATE_TO = 'dateTo';